import React, { useState } from 'react';
import { connect } from 'react-redux';
import { RegisterRequest } from '../../../models/account/register/RegisterRequest';
import I18n from '../../../blocks/localization';
import { Button, Col, FormGroup, Input, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ErrorMessage, Formik } from 'formik';
import { registerValidationSchema } from '../../../blocks/validation/validationSchema';
import PrometModal from '../../shared/Modal';
import { registerActions } from '../../../store/account/actions';
import VerticalDivider from '../../shared/VerticalDivider';
import ContentLayoutWithoutNavigation from '../../core/ContentLayoutWithoutNavigation';
import TermsOfUseContent from '../TermsOfUseContent';
import RightBanners from '../../core/RightBanners';

type Props = typeof mapDispatchToProps;

const Register = (props: Props) => {
    const [isTermsOfUseModalOpen, setIsTermsOfUseModalOpen] = useState(false);

    const termsOfUseModalClose = () => setIsTermsOfUseModalOpen(false);
    const termsOfUseModalOpen = () => setIsTermsOfUseModalOpen(true);

    const initialRegisterRequest = { email: '', password: '', firstName: '', lastName: '', passwordConfirm: '', areTermsOfUseAccepted: false } as RegisterRequest;

    const handleFormSubmit = (registerRequest: RegisterRequest) => {
        props.register(registerRequest);
    }

    return (
        <ContentLayoutWithoutNavigation>
            <h1>{I18n.t('register.title')}</h1>

            <Row>
                <Col xl={7} lg={6} className="mb-3">
                    <h3>{I18n.t('register.register')}</h3>

                    <Formik
                        validationSchema={registerValidationSchema}
                        validateOnBlur
                        initialValues={initialRegisterRequest}
                        enableReinitialize
                        onSubmit={(values) => handleFormSubmit(values)}>
                        {({ handleChange, handleSubmit, values, errors, touched }) => {
                            return (
                                <form onSubmit={handleSubmit}>
                                    <FormGroup>
                                        <Input type="text" name="firstName" onChange={handleChange} placeholder={I18n.t('register.form.firstName')}
                                            className={errors.firstName && touched.firstName ? ' is-invalid' : ''} />
                                        <ErrorMessage name="firstName" component="div" className="invalid-feedback" />
                                    </FormGroup>
                                    <FormGroup>
                                        <Input type="text" name="lastName" onChange={handleChange} placeholder={I18n.t('register.form.lastName')}
                                            className={errors.lastName && touched.lastName ? ' is-invalid' : ''} />
                                        <ErrorMessage name="lastName" component="div" className="invalid-feedback" />
                                    </FormGroup>
                                    <FormGroup>
                                        <Input type="text" name="email" onChange={handleChange} placeholder={I18n.t('register.form.email')}
                                            className={errors.email && touched.email ? ' is-invalid' : ''} />
                                        <ErrorMessage name="email" component="div" className="invalid-feedback" />
                                    </FormGroup>
                                    <FormGroup>
                                        <Input type="password" name="password" onChange={handleChange} placeholder={I18n.t('register.form.password')}
                                            className={errors.password && touched.password ? ' is-invalid' : ''} />
                                        <ErrorMessage name="password" component="div" className="invalid-feedback" />
                                    </FormGroup>
                                    <FormGroup>
                                        <Input type="password" name="passwordConfirm" onChange={handleChange} placeholder={I18n.t('register.form.passwordConfirm')}
                                            className={errors.passwordConfirm && touched.passwordConfirm ? ' is-invalid' : ''} />
                                        <ErrorMessage name="passwordConfirm" component="div" className="invalid-feedback" />
                                    </FormGroup>
                                    <FormGroup>
                                    </FormGroup>
                                    <FormGroup>
                                        <input type="checkbox" name="areTermsOfUseAccepted" onChange={handleChange}
                                            className={'mr-2' + (errors.areTermsOfUseAccepted && touched.areTermsOfUseAccepted ? ' is-invalid' : '')} />
                                        <span>{I18n.t('register.form.termsOfUseAccept')}</span> &nbsp;
                                        <Link to={{}} className="text-decoration-underline" onClick={termsOfUseModalOpen}>{I18n.t('findOutMore')}</Link>

                                        <br />

                                        <ErrorMessage name="areTermsOfUseAccepted" component="div" className="invalid-feedback" />

                                    </FormGroup>

                                    <Button type="submit" color="primary" onClick={handleSubmit}>{I18n.t('register.button')}</Button>
                                </form>
                            );
                        }}
                    </Formik>
                </Col>

                <Col xl={1} className="d-none d-xl-block">
                    <VerticalDivider />
                </Col>

                <Col xl={4} lg={6}>
                    <RightBanners />
                </Col>
            </Row>

            <PrometModal
                isOpen={isTermsOfUseModalOpen}
                onOkClick={termsOfUseModalClose}
                onClose={termsOfUseModalClose}
                footer
                headerText={I18n.t('termsOfUse.title')}
                okText={I18n.t('close')}
                size='lg'
            >
                <TermsOfUseContent height='400px' />
            </PrometModal>
        </ContentLayoutWithoutNavigation>
    );
}

const mapDispatchToProps = {
    register: registerActions.request
};

export default connect(null, mapDispatchToProps)(Register as any);
